export function formatType(status) {
    if (status === 'fixing')
        return "Dépannage";
    if (status === 'inspection')
        return "Visite de contrat";
    if (status === 'quote_execution')
        return "Exécution devis";
    if (status === 'on_call')
        return "OT sous astreinte";
    if (status === 'commissioning')
        return "Mise en service";

    return status;
}
